import React from 'react';

export function Refrences(){
    return(
        <div></div>
    )
}

export default Refrences;